import type { JSX } from "react";

// Clause text is stored as HTML (authored in the rich editor). Convert it to
// READABLE text for the card: block tags → line breaks, drop the rest, decode a
// few common entities — so the card never shows raw "<h2>…</h2><p>…</p>" markup.
export function htmlToText(s: string): string {
  return s
    .replace(/<\s*br\s*\/?>/gi, "\n")
    .replace(/<\/(p|h[1-6]|li|div|tr|blockquote)>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

// Render a clause's draft text (as clean text) with the deviating span struck
// through. The span is matched against the CONVERTED text; if not found (or
// null), the text renders plain. Line breaks are preserved via CSS (pre-wrap).
export function DraftWithDeviation({
  text,
  span,
}: {
  text: string;
  span: string | null;
}): JSX.Element {
  const plain = htmlToText(text);
  const plainSpan = span === null ? "" : htmlToText(span);
  if (plainSpan.length === 0) return <>{plain}</>;
  const at = plain.indexOf(plainSpan);
  if (at < 0) return <>{plain}</>;
  return (
    <>
      {plain.slice(0, at)}
      <span className="sa-rev__strike">{plainSpan}</span>
      {plain.slice(at + plainSpan.length)}
    </>
  );
}
